__turbopack_context__.v({
  "article": "CNews-module__c08PoG__article",
  "articleBack": "CNews-module__c08PoG__articleBack",
  "articleBackLink": "CNews-module__c08PoG__articleBackLink",
  "articleDate": "CNews-module__c08PoG__articleDate",
  "articleHeader": "CNews-module__c08PoG__articleHeader",
  "articleLead": "CNews-module__c08PoG__articleLead",
  "articleMainImage": "CNews-module__c08PoG__articleMainImage",
  "articleTitle": "CNews-module__c08PoG__articleTitle",
  "body": "CNews-module__c08PoG__body",
  "card": "CNews-module__c08PoG__card",
  "cardLink": "CNews-module__c08PoG__cardLink",
  "date": "CNews-module__c08PoG__date",
  "empty": "CNews-module__c08PoG__empty",
  "error": "CNews-module__c08PoG__error",
  "list": "CNews-module__c08PoG__list",
  "more": "CNews-module__c08PoG__more",
  "pagination": "CNews-module__c08PoG__pagination",
  "paginationHint": "CNews-module__c08PoG__paginationHint",
  "paginationInfo": "CNews-module__c08PoG__paginationInfo",
  "root": "CNews-module__c08PoG__root",
  "short": "CNews-module__c08PoG__short",
  "thumb": "CNews-module__c08PoG__thumb",
  "thumbWrap": "CNews-module__c08PoG__thumbWrap",
  "title": "CNews-module__c08PoG__title",
});
